<template>
  <div>
    <ul v-if="isPictureCard" name="el-list"
      :class="[
        'el-upload-list',
        'el-upload-list--' + listType,
        { 'is-disabled': disabled }
      ]">

      <li v-for="(file, findex) in fileList" :key="`${findex}`"
        tabindex="0"
        :class="['el-upload-list__item', 'is-' + file.status]"
        style="position:relative;">
        <!-- , focusing ? 'focusing' : '', v-loading="file.status === 'progress'" -->

        <img :src="file.url" class="el-upload-list__item-thumbnail" />
        <a class="el-upload-list__item-name">
          <i class="el-icon-document">
            {{ file.name }}
          </i>
        </a>

        <label class="el-upload-list__item-status-label"
          v-if="file.hasOwnProperty('fullUrl') && file.fullUrl.length > 0">
          <i :class="{
            'el-icon-upload-success': true,
            'el-icon-circle-check': listType === 'text',
            'el-icon-check': ['picture-card', 'picture'].indexOf(listType) > -1
          }"></i>
        </label>
        <i class="el-icon-close" v-if="!disabled"></i>
        <!-- <i class="el-icon-close-tip" v-if="!disabled">press delete to remove</i> -->

        <el-progress
          v-if="file.status === 'uploading'"
          :type="listType === 'picture-card' ? 'circle' : 'line'"
          :stroke-width="listType === 'picture-card' ? 6 : 2"
          :percentage="parsePercentage(file.percentage)">
        </el-progress>

        <span class="el-upload-list__item-actions" v-if="listType === 'picture-card'">
          <span class="el-upload-list__item-preview" v-if="onFilePreview && listType === 'picture-card'" @click="onFilePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <!-- <span class="el-upload-list__item-delete" v-if="onFileRemove && listType === 'picture-card'" @click="onFileRemove(file)">
            <i class="el-icon-delete"></i>
          </span> -->
          <!-- <div style="position:absolute;bottom:8px;left:0;width:100%;">
            <el-button class="uppercase color-info"
              style="width:90%;"
              size="mini" type="info"
              @click="onFileSelect(file)">
              Select
            </el-button>
          </div> -->

          <div style="position:absolute;top:0;left:0;width:95%;">
            <div class="el-upload__tip" style="color:white;word-break:break-all;">
              {{ getFilenameHint(file.name) }}
            </div>
          </div>
        </span>

        <div style="position:absolute;bottom:4px;width:100%;opacity:0.8;" v-if="listType === 'picture-card' && file && file.status !== 'uploading'">
          <el-button class="uppercase color-info"
            style="width:90%;"
            size="mini" type="info"
            @click="onFileSelect(file)">
            Select
          </el-button>
        </div>

      </li>
    </ul>

    <el-upload
      class="onboarding-upload"
      :class="[(disabled ? 'is-disabled' : ''), (isDrop ? 'is-drop' : ''), (isPictureCard ? 'is-picture-card' : 'is-full')]"
      :style="[(isPictureCard ? { display: 'inline-block' } : { width: '100%' })]"
      ref="upload"
      action="upload"
      :http-request="isAutoUpload ? onFileAutoUpload : () => {}"
      :accept="accept"
      :multiple="false"
      :limit="limit"
      :disabled="disabled"
      :before-upload="onFileBeforeUpload"
      :on-preview="onFilePreview"
      :on-exceed="onFileExceed"
      :on-change="onFileChange"
      :on-remove="onFileRemove"
      :on-progress="onFileProgress"
      :on-success="onFileSuccess"
      :drag="isDrop && !isPictureCard"
      :auto-upload="isAutoUpload"
      :show-file-list="showFileList == null ? true : showFileList"
      :file-list="fileList"
      :list-type="listType || 'picture'">
      <i v-if="isPictureCard" class="el-icon-plus"></i>
      <el-button
        v-if="!isDrop && !isUploadHidden && !isPictureCard"
        class="is-hidden-print uppercase"
        size="small" type="info"
        :style="buttonStyle">
        {{ buttonLabel || 'Add File' }}
      </el-button>
      <i v-if="isDrop && !isUploadHidden && !isPictureCard" class="el-icon-upload"></i>
      <div v-if="isDrop && !isUploadHidden && !isPictureCard" class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <!-- <div v-if="isDrop && !isUploadHidden" class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
      <div v-if="!isPictureCard" slot="tip" class="el-upload__tip is-fade-print" style="margin-left:0;display:block;">
        {{ tip || `accepted files: ${acceptedFiles}` }}
      </div>
    </el-upload>
  </div>
</template>

<script>
import File from '@/apis/file'

export default {
  name: 'onboarding-upload',
  components: {
  },
  props: ['field', 'index', 'file-list', 'disabled', 'accept', 'list-type', 'tip', 'limit', 'show-file-list', 'button-label', 'button-style', 'is-upload-hidden', 'is-drop', 'is-auto-upload'],
  data () {
    return {
    }
  },
  computed: {
    acceptedFiles: function () {
      if (!this.accept || this.accept.length <= 0) return '*'
      let files = this.accept.split(',')
      let info = File.getMimeFileTypes()
      let accepted = []
      for (let f in files) {
        let file = files[f]
        accepted = accepted.concat(info[file] || [])
      }
      return accepted.join('/')
    },

    isPictureCard: function () {
      return this.listType === 'picture-card'
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
  },
  methods: {
    parsePercentage (val) {
      return parseInt(val, 10)
    },
    getFilenameHint (name) {
      if (!name) return name
      if (typeof name !== 'string') return name
      return name.split(/(\\|\/)/g).pop()
      // let MAX = 20
      // if (name.length <= MAX) return name
      // return '...' + name.substring(name.length - MAX, name.length)
    },
    onFileBeforeUpload: function (file) { // no filelist
      // console.log('on-file-before-upload', {
      //   file
      // })
      this.$emit('on-file-before-upload', {
        field: this.field,
        index: this.index,
        file
      })
    },
    onFileAutoUpload: function (file) { // no filelist
      // console.log('on-file-auto-upload', {
      //   file
      // })
      this.$emit('on-file-auto-upload', {
        field: this.field,
        index: this.index,
        file
      })
    },
    onFileSelect: function (file) { // no filelist
      // console.log('on-file-select', {
      //   file
      // })
      this.$emit('on-file-select', {
        field: this.field,
        index: this.index,
        file
      })
    },
    onFilePreview: function (file) {
      // console.log('on-file-preview', {
      //   file
      // })
      this.$emit('on-file-preview', {
        field: this.field,
        index: this.index,
        file
      })
    },
    onFileExceed: function (file, fileList) {
      // console.log('on-file-exceed', {
      //   file, fileList
      // })
      this.$emit('on-file-exceed', {
        field: this.field,
        index: this.index,
        file,
        fileList
      })
    },
    onFileChange: function (file, fileList) {
      // console.log('on-file-change', {
      //   file, fileList
      // })
      this.$emit('on-file-change', {
        field: this.field,
        index: this.index,
        file,
        fileList
      })
    },
    onFileRemove: function (file, fileList) {
      // console.log('on-file-remove', {
      //   file, fileList
      // })
      this.$emit('on-file-remove', {
        field: this.field,
        index: this.index,
        file,
        fileList
      })
    },
    onFileProgress: function (ev, file, fileList) {
      // console.log('on-file-progress', {
      //   ev, file, fileList
      // })
      this.$emit('on-file-progress', {
        event: ev,
        field: this.field,
        index: this.index,
        file,
        fileList
      })
    },
    onFileSuccess: function (res, file, fileList) {
      // console.log('on-file-success', {
      //   res, file, fileList
      // })
      this.$emit('on-file-success', {
        field: this.field,
        index: this.index,
        res,
        file,
        fileList
      })
    }
  }
}
</script>

<style lang="scss">
// @import "../onboarding/styles/onboarding.scss";

.onboarding-upload {
  // .el-upload {
  //   width: 100%;
  // }
  // &.is-picture-card {
  //   .el-upload {
  //     width: auto;
  //   }
  // }

  .el-upload {
    display: block;
  }

  &.is-full {
    .el-upload {
      width: 100%;
    }
  }

  &.is-disabled {
    .el-upload .el-button {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  &.is-drop {
    .el-upload .el-upload-dragger {
      margin-left: auto;
      margin-right: auto;
    }
  }

  .el-upload .el-button {
    padding: 12px 20px;
    width: 100%;
  }

  // for picture-card only
  .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete {
    display: none;
  }

  .el-upload__tip {
    display: inline-block;
    margin-left: 12px;
  }
}

</style>
